
import Vue from "vue";
import $ from "jquery";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";

import { PaginationState } from "@/store/types";
import { CountryModel, ProvinceModel } from "@/models/region.model";

import toast from "@/functions/toast.function";
import { SCHOOL_PARTNERSHIP } from "@/constants/enum.constant";

@Component
export default class Company extends Vue {
  /* VUEX */

  // ACTIONS
  @Action("actionSelectProvince", { namespace: "region" })
  private actionSelectProvince: any;
  @Action("actionSelectEmployer", { namespace: "employer" })
  private actionSelectEmployer: any;
  @Action("actionPaginationEmployer", { namespace: "employer" })
  private actionPaginationEmployer: any;
  @Action("actionResetEmployer", { namespace: "employer" })
  private actionResetEmployer: any;
  @Action("appNewLayout") private appNewLayout: any;

  // GETTERS
  @Getter("arrayCountry", { namespace: "region" }) private arrayCountry: any;
  @Getter("arrayProvince", { namespace: "region" }) private arrayProvince: any;

  // STATE
  @State("locale")
  private locale: any;
  @State("employer", { namespace: "employer" }) private employer: any;
  @State("array_employer", { namespace: "employer" })
  private array_employer: any;
  @State("pagination_employer", { namespace: "employer" })
  private pagination_employer: PaginationState;

  // WATCH
  @Watch("employer.country")
  private onChangeCountry(val: CountryModel) {
    setTimeout(() => {
      (this.$refs.searchCompany as any).show();
    }, 500);
    this.actionSelectProvince(val);
  }

  @Watch("employer.province")
  private onChangeProvince(val: ProvinceModel) {
    setTimeout(() => {
      (this.$refs.searchCompany as any).show();
    }, 500);
  }

  /* INITIALIZATION */
  private onLoad: boolean = false;
  private activePage: number = 1;

  constructor() {
    super();
  }

  /* LIFECYLCE */

  private created() {
    this.appNewLayout();
    this.actionResetEmployer();
    this.clickSearch();
    const self = this;

      $(window).scroll(function () {
        const { name } = self.$route;

        if (name === "company") {
          const height = ($(document).height() as number) - ($(window).height() as number) - 20;
          if (($(window).scrollTop() as number) >= height) {
            if (!self.onLoad) {
              if (self.array_employer.length == 0) {
                return;
              }
              if (self.onLoad) {
                return;
              }
              if (self.pagination_employer.url) {
                self.activePage++;
                self.clickPage(self.activePage, self.pagination_employer.url);
              }
            }
          }
        }
    });
  }

  private mounted() {
    if (this.$route.query.search != undefined) {
      (this.$refs["dropFilter"] as any).show();
      $("html, body").animate(
        {
          scrollTop: ($("#dropFilter") as any).offset().top - 200,
        },
        500
      );
    }

    window.onscroll = (e: any) => {
      const { name } = this.$route;

      if (name === "company") {
        let scrollElem = (document.scrollingElement as HTMLElement)
        let canLoad = scrollElem.scrollTop + window.innerHeight >= scrollElem.scrollHeight - 10
        if (canLoad && !this.onLoad) {
          if (this.pagination_employer.url) {
            this.activePage++;
            this.clickPage(this.activePage, this.pagination_employer.url);
          }
        }
      }
    }
  }

  /* METHODS */
  private isPartnership(data: any) {
    if (data.partnership) return data.partnership.latest_history.status === SCHOOL_PARTNERSHIP.ACTIVE;
    return false;
  }

  private clickSearch() {
    if (this.employer.total_candidate && this.employer.total_candidate < 0) {
      toast.warning(this.$t("warning_applicant_minus"));
      return;
    } else {
      this.actionSelectEmployer({
        success: () => {
          (this.$refs.searchCompany as any).hide();
          // Show Filter From Dashboard
          const { search } = this.$route.query;
          if (search && search === "dashboard") {
            (this.$refs.searchCompany as any).show();
          }
        },
      });
    }
  }

  private onReset() {
    this.actionResetEmployer();
    this.clickSearch();
  }

  private clickPage(page: number, url: string) {
    const params = Object.assign({}, this.employer);
    try {
      params.country = (this.employer.country as any).id;
      params.province = (this.employer.province as any).id;
    } catch {
      params.country = null;
      params.province = null;
    }
    this.onLoad = true;
    if (url) {
      this.actionPaginationEmployer({
        url,
        page,
        params,
        success: () => {
          this.onLoad = false;
        },
      });
    } else {
      this.clickSearch();
    }
  }
}
